export default "__VITE_ASSET__ouDmF2DO__"